import * as React from 'react';
/**
 *
 * Original name: email off
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=29923%3A6766
 *
 */
export const EmailOffLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "m20 8.892-1.5 1.5v5.358a.75.75 0 0 1-.75.75h-5.358l-1.5 1.5h6.858A2.25 2.25 0 0 0 20 15.75V8.892Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m6.19 20.581-1-1L6.77 18h-.52A2.25 2.25 0 0 1 4 15.75V6h14.77l1.269-1.268 1 1-14.85 14.85Zm7.646-9.646L17.271 7.5H6.606L12 12.707l1.836-1.772ZM8.271 16.5l2.7-2.7L5.5 8.515v7.234a.75.75 0 0 0 .75.75h2.02Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
